import React, { useState } from "react";
import "../Pages/stylenews.css";
import { Container, Row, Col } from "react-bootstrap";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAboutUs } from "../Store/Actions/company";
import { axiosGet, baseURL } from "../Store/Actions";
import Breadcrumb from "../component/Breadcrumb";
import DefaultImage from "../Assets/default-image.png";

function News() {
  const [news, setNews] = useState([])
  const getNews = async () => {
    await axiosGet("news-content").then((res) => {
      setNews(res[0].data);
    });
  };
  useEffect(() => {
    getNews();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const dateFormat = (input) => {
    const date = new Date(input);
    const formatted = date.toLocaleDateString("id-ID", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });

    return formatted;
  }

  function truncateHtml(html, maxLength) {
    if (!html) return "";
    const text = html.replace(/<[^>]+>/g, "");
    const shortText = text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    return `<p>${shortText}</p>`;
  }


  return (
    <div className="NewsContent">
      <style>
        {`
          .news-content, .news-content * {
            font-size: 14px !important;
            line-height: 1.4;
          }
        `}
      </style>
      <Breadcrumb />
      <Container fluid>
        <div className="DefaultTitlePage">NEWS</div>
        <Row>
          {news.map((newsDetail, index) => (
            <Col key={index} lg={4} md={6} sm={12} style={{ marginBottom: "25px", height: "500px" }}>
              <div
                className="right-boxed"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between"
                }}
              >
                <div>
                  {newsDetail?.image_news === null ? (
                    <img src={DefaultImage} alt={`NewsImage${index}.png`} style={{
                      width: "100%", height: "230px", objectFit: "cover",        // agar proporsi tetap & gambar ter-crop
                      objectPosition: "center"
                    }} />
                  ) : (
                    <img src={`${baseURL}/${newsDetail?.image_news}`} alt={`NewsImage${index}.png`} style={{
                      width: "100%", height: "230px", objectFit: "cover",        // agar proporsi tetap & gambar ter-crop
                      objectPosition: "center"
                    }} />
                  )}
                  <div style={{ fontFamily: "Poppins", fontSize: "18px", fontWeight: "700", marginTop: "15px", lineHeight: "1.3", minHeight: "60px" }}>
                    {newsDetail.title.length > 60 ? newsDetail.title.substring(0, 60) + "..." : newsDetail.title}
                  </div>
                  <div className="news-content" style={{ marginTop: "10px", marginBottom: "10px" }}
                    dangerouslySetInnerHTML={{ __html: truncateHtml(newsDetail?.content, 100) }}
                  />
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div style={{ fontSize: "14px", fontWeight: "500", backgroundColor: "#F4F4F4", padding: "5px 10px", borderRadius: "5px" }}>{dateFormat(newsDetail.createdAt)}</div>
                  <div style={{
                    color: "#BE1620",
                    cursor: "pointer",
                    fontFamily: "Poppins",
                    fontWeight: "600"
                  }} onClick={() => window.location.href = `/news/${encodeURIComponent(newsDetail.title)}/${newsDetail.id}`}>{'View More >'}</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
export default News;
